import o from "./getConsentedPolicyVersion.mjs";
const t = ({ latestPolicyVersion: e }) => {
  if (!e)
    return !1;
  const n = o();
  return n ? n < e : !0;
};
export {
  t as default
};
